import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined';
import SectionCard from 'components/section/SectionCard';

const AddNewVersionCard = ({ onClick }) => {
	return (
		<SectionCard>
			<Box
				sx={{
					minHeight: '300px',
					display: 'flex',
					flexDirection: 'column', // Stack the icon and text vertically
					justifyContent: 'center', // Center vertically within the 20vh
					alignItems: 'center', // Center horizontally
					gap: 1.5, // Add clean space between the icon and the text lines
				}}
			>
				<FindInPageOutlinedIcon sx={{ fontSize: '3.5rem', color: 'grey.400' }} />

				<Box sx={{ textAlign: 'center' }}>
					<Typography variant="h6" sx={{ fontWeight: 500, color: 'text.secondary' }}>
						No Policy Available
					</Typography>
					<Typography variant="body1" color="text.secondary">
						Get started by{' '}
						<Box component="span" sx={{ color: '#0052CC', textDecoration: 'underline', cursor: 'pointer' }} onClick={onClick}>
							creating the first policy
						</Box>
						.
					</Typography>
				</Box>
			</Box>
		</SectionCard>
	);
};

AddNewVersionCard.propTypes = {
	onClick: PropTypes.func.isRequired,
};

export default AddNewVersionCard;
